import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "cinema-slide__content movie hide-scrollbar disable-overscroll-y"
};
const _hoisted_2 = {
  key: 1,
  class: "wrapper"
};
const _hoisted_3 = {
  key: 0,
  class: "loading"
};
import Card from '@remote/components/cinema/CinemaCard.vue';
import { useDeviceStore } from '@remote/store/device';
import CinemaEmpty from '@remote/components/cinema/CinemaEmpty.vue';
import { stat } from '@remote/utils/stat';
import { watch } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'CinemaSlideMovie',
  props: {
    isShowing: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const deviceStore = useDeviceStore();
    watch(() => props.isShowing, () => {
      if (props.isShowing) {
        var _deviceStore$currentN, _deviceStore$currentN2;
        stat({
          action: 'cinema_channel_show',
          data: {
            if_content_blank: ((_deviceStore$currentN = deviceStore.currentNFOInstance) === null || _deviceStore$currentN === void 0 ? void 0 : _deviceStore$currentN.movieList.length) === 0 ? 1 : 0,
            page: 'movie',
            status: (_deviceStore$currentN2 = deviceStore.currentNFOInstance) !== null && _deviceStore$currentN2 !== void 0 && _deviceStore$currentN2.isScraping ? 1 : 0
          }
        });
      }
    });
    return (_ctx, _cache) => {
      var _unref$currentNFOInst, _unref$currentNFOInst2, _unref$currentNFOInst4, _unref$currentNFOInst5, _unref$currentNFOInst6;
      const _directive_observer = _resolveDirective("observer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [((_unref$currentNFOInst = _unref(deviceStore).currentNFOInstance) === null || _unref$currentNFOInst === void 0 ? void 0 : _unref$currentNFOInst.movieList.length) === 0 ? (_openBlock(), _createBlock(CinemaEmpty, {
        key: 0,
        "has-list-init": _unref(deviceStore).currentNFOInstance.hasMovieListInit
      }, null, 8, ["has-list-init"])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref$currentNFOInst2 = _unref(deviceStore).currentNFOInstance) === null || _unref$currentNFOInst2 === void 0 ? void 0 : _unref$currentNFOInst2.movieList, item => {
        var _item$video_info, _unref$currentNFOInst3;
        return _openBlock(), _createBlock(Card, {
          key: (_item$video_info = item.video_info) === null || _item$video_info === void 0 ? void 0 : _item$video_info.file_id,
          nfo: item,
          "is-poster-show": (_unref$currentNFOInst3 = _unref(deviceStore).currentNFOInstance) === null || _unref$currentNFOInst3 === void 0 ? void 0 : _unref$currentNFOInst3.isPosterShow,
          "click-from": "movie",
          from: "movie"
        }, null, 8, ["nfo", "is-poster-show"]);
      }), 128)), !((_unref$currentNFOInst4 = _unref(deviceStore).currentNFOInstance) !== null && _unref$currentNFOInst4 !== void 0 && _unref$currentNFOInst4.isMovieListEnd) && !((_unref$currentNFOInst5 = _unref(deviceStore).currentNFOInstance) !== null && _unref$currentNFOInst5 !== void 0 && _unref$currentNFOInst5.isScraping) ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, null, 512)), [[_directive_observer, {
        show: (_unref$currentNFOInst6 = _unref(deviceStore).currentNFOInstance) === null || _unref$currentNFOInst6 === void 0 ? void 0 : _unref$currentNFOInst6.loadMovieNFOList
      }]]) : _createCommentVNode("", true)]))]);
    };
  }
});